import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { getCategories } from '../../api/category.api';
import Typography from '@mui/material/Typography';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import FooterLogo from '../../assets/images/Footer/JdecorLogo.png';
import { Link } from 'react-router-dom';
import MobileIcon from '../../assets/icons/FooterIcon/Mobile Icon.png'
import MessageIcon from '../../assets/icons/FooterIcon/Message Icon.png'
import WhatsAppIcon from '../../assets/icons/FooterIcon/WhatsApp Icon.png'



function Footer({ isAuthenticated = false, isApproved = false }) {
  const showCategories = isAuthenticated && isApproved;
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (showCategories) {
      getCategories()
        .then(data => {
          if (data && data.length > 0) {
            setCategories(data.slice(0, 4));
          }
        })
        .catch(err => console.error("Error fetching categories for footer:", err));
    }
  }, [showCategories]);

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: "rgba(255, 244, 223, 1)",
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      paddingTop: { xs: "40px", sm: "50px" },
      paddingBottom: { xs: "40px", sm: "50px" },
    }}>

      <Box sx={{
        height: "100%",
        width: { xs: "90%", sm: showCategories ? "20%" : "22%" },
        display: "flex",
        alignItems: "center",
        justifyContent: { sm: "flex-start" },
        marginLeft: { xs: "10%", sm: showCategories ? "5%" : "8%" },
      }}>
        <Box sx={{
          width: { xs: "30%", sm: "50%" },
          paddingTop: { xs: "0px", sm: "15px", lg: "40px" }
        }}>
        <Link to="/" >
          <LazyLoadImage
            src={FooterLogo}
            effect="blur"
            width="100%"
            height="100%"
          />
          </Link>
        </Box>
      </Box>

      <Box sx={{
        width: { xs: "90%", sm: showCategories ? "40%" : "25%" },
        display: "flex",
        marginLeft: { xs: "10%", sm: "0" },
        height: { xs: "auto", sm: "100%" },
        marginTop: { xs: "30px", sm: "0px", lg: "20px" },
      }}>
        {showCategories && (
          <Box sx={{
            width: "50%",
            height: "100%",
          }}>
            <Typography variant='h4' sx={{ fontSize: "17px", fontWeight: "600", color: "rgba(45, 44, 44, 1)", marginTop: { xs: "0px", sm: "15px" } }}>Categories</Typography>
            {categories.map((cat, index) => (
              <Typography key={cat.ID} variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: index === 0 ? "16px" : "12px" }}>
                <Link to={`/shop/${cat.ID}`} style={{ textDecoration: 'none', color: 'rgba(45, 44, 44, 1)' }}>
                  {cat.Category}
                </Link>
              </Typography>
            ))}
          </Box>
        )}
        <Box sx={{
          width: { xs: showCategories ? "50%" : "100%", sm: showCategories ? "50%" : "90%" },
          height: "100%",
          marginLeft: { xs: "0", sm: showCategories ? "0" : "10%" }
        }}>
          <Typography variant='h4' sx={{ fontSize: "17px", fontWeight: "600", color: "rgba(45, 44, 44, 1)", marginTop: { xs: "0px", sm: "15px" } }}>Quick Links</Typography>
          <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "16px" }}>
          <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}}  to="/"> Home</Link>

          </Typography>
          <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "12px" }}>
          <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}}  to="/About"> About Us</Link>

          </Typography>
          {showCategories && (
            <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "12px" }}>
              <Link to="/shop" style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}}   >Shop</Link>
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={{
        height: "100%",
        width: { xs: "90%", sm: showCategories ? "40%" : "45%" },
        display: "flex",
        marginLeft: { xs: "10%", sm: "0" },
        marginTop: { xs: "40px", sm: "0px", lg: "20px" },
      }}>
        <Box sx={{
          width: "50%",
          height: "100%",
        }}>
          <Typography variant='h4' sx={{ fontSize: "17px", fontWeight: "600", color: "rgba(45, 44, 44, 1)", marginTop: { xs: "0px", sm: "15px" } }}>Help</Typography>
          <Typography variant='h6' sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "16px" }}>
            <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}} to="/terms">Terms & Conditions</Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "12px" }}>
            <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}} to="/privacy">Privacy Policy</Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "12px" }}>
            <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}} to="/delivery-returns">Delivery & Return</Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)", marginTop: "12px" }}>
            <Link style={{textDecoration:"none",color: "rgba(45, 44, 44, 1)"}} to="/Contactus"> Contact Us</Link>
          </Typography>
        </Box>
        <Box sx={{
          width: "50%",
          height: "100%",
        }}>

          <Typography variant='h4' sx={{ fontSize: "17px", fontWeight: "600", color: "rgba(45, 44, 44, 1)", marginTop: { xs: "0px", sm: "15px" } }}>Contact Us</Typography>
          <Box sx={{ display: "flex", alignItems: "center", marginTop: "16px" }}>
            <Box component="img" src={MobileIcon} alt="Mobile Icon" sx={{ marginRight: "8px",width:"16px" }} />
            <Typography variant='h6' sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)" }}>7711053053</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", marginTop: "12px" }}>
            <Box component="img" src={MessageIcon} alt="Message Icon" sx={{ marginRight: "8px",width:"16px" }} />
            <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)" }}>Sales@Jdecor.in</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", marginTop: "12px" }}>
            <Box component="img" src={WhatsAppIcon} alt="WhatsApp Icon" sx={{ marginRight: "8px",width:"16px" }} />
            <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "500", color: "rgba(45, 44, 44, 1)" }}>7030715353</Typography>
          </Box>
        </Box>
      </Box>

    </Box>
  )
}

export default Footer;
